export const pickLocalized = <T>(base: T, localized: T, isEn: boolean): T =>
  isEn ? localized || base : base || localized;
